module.exports = __webpack_public_path__ + "static/media/pencil-white.bceb2ca8.svg";